<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  html {
    background-color: #f4f4f4;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue